module.exports = __webpack_public_path__ + "img/icon_sportMenu_waterpolo.b6ae40ba.svg";